import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import MailingsTypesListView from "./mailingsTypes-list.html";
import MailingsTypesEditView from "./mailingsTypes-edit.html";


angular.module("mailings_types", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('mailings_types', {
                url: "/mailings_types",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('mailings_types.list', {
                url: "/list",
                controller: "MailingTypesListCtrl",
                template: MailingsTypesListView,
                // requiredPermission: ["MAILINGS_READ"]
            })
            .state('mailings_types.edit', {
                url: "/edit/:id",
                controller: "MailingTypesEditCtrl",
                template: MailingsTypesEditView,
                // requiredPermission: ["MAILINGS_READ"]
            })
    }])
    ;